export enum RuleKind {
    MODEL = 0,
    FIELD = 1,
    PROCESS = 2,
    STEP = 3,
    HOOK_MODEL = 5,
    MENU = 6
}
